/**
 * Object containing all API endpoints used in the application
 * Updated to match the new backend API structure
 */
export const endpoints = {
  // Health endpoint
  health: '/health',

  // Customer endpoints - Updated to match new backend API
  customers: {
    getAll: '/api/v1/customers',
    getById: (id) => `/api/v1/customers/${id}`,
    create: '/api/v1/customers',
    update: (id) => `/api/v1/customers/${id}`,
    delete: (id) => `/api/v1/customers/${id}`,
  },

  // Site endpoints - Updated to match new backend API
  sites: {
    getAll: '/api/v1/sites',
    getById: (id) => `/api/v1/sites/${id}`,
    create: '/api/v1/sites',
    update: (id) => `/api/v1/sites/${id}`,
    delete: (id) => `/api/v1/sites/${id}`,
    getIssueHistory: (id) => `/api/v1/sites/${id}/issue-history`,
    // Site Video endpoints from API documentation
    getVideoAvailableDates: (id) => `/api/v1/sites/${id}/videos/available-dates`,
    getVideoTimeline: (id) => `/api/v1/sites/${id}/videos/timeline`,
    getVideoTimelineBatch: (id) => `/api/v1/sites/${id}/videos/timeline/batch`,
    getSynchronizedVideos: (id) => `/api/v1/sites/${id}/videos/synchronized`,
    getSynchronizedFrames: (id) => `/api/v1/sites/${id}/videos/synchronized-frames`,
    // Site-level aggregation endpoints
    getCycleTimes: (id) => `/api/v1/sites/${id}/cycle-times`,
  },

  // Vehicle endpoints - Updated to match new backend API
  vehicles: {
    getAll: '/api/v1/vehicles',
    getById: (id) => `/api/v1/vehicles/${id}`,
    getDetails: (id) => `/api/v1/vehicles/${id}/details`,
    getCycleTimes: (id) => `/api/v1/vehicles/${id}/cycle-times`,
    getTotalUptime: (id) => `/api/v1/vehicles/${id}/total-uptime`,
    getIssueHistory: (id) => `/api/v1/vehicles/${id}/issue-history`,
    getQuickBaseIssues: (id) => `/api/v1/quickbase/vehicles/${id}/issues`,
    getGrains: (id) => `/api/v1/vehicles/${id}/grains`,
    getVideos: (id) => `/api/v1/vehicles/${id}/videos`,
    getGpsTrack: (id) => `/api/v1/vehicles/${id}/gps-track`,
    getVideoClock: (id) => `/api/v1/vehicles/${id}/videos/clock`,
    create: '/api/v1/vehicles',
    update: (id) => `/api/v1/vehicles/${id}`,
    delete: (id) => `/api/v1/vehicles/${id}`,
    // Batch endpoints for optimized performance
    getDetailsBatch: '/api/v1/vehicles/details/batch',
    getCycleTimesBatch: '/api/v1/vehicles/cycle-times/batch',
    getLiveStatusBatch: '/api/v1/vehicles/live-status/batch',
  },

  // Control station endpoints - Updated to match new backend API
  controlStations: {
    getAll: '/api/v1/control-stations',
    getById: (id) => `/api/v1/control-stations/${id}`,
    create: '/api/v1/control-stations',
    update: (id) => `/api/v1/control-stations/${id}`,
    delete: (id) => `/api/v1/control-stations/${id}`,
    getGrains: (id) => `/api/v1/control-stations/${id}/grains`, // admin-only (403 otherwise)
    getIssueHistory: (id) => `/api/v1/control-stations/${id}/issue-history`,
  },

  // Permission profile: primary_role, has_all_access, accessible_customer_ids.
  // /auth/roles and /auth/debug are admin-only and not used by the UI.
  auth: {
    userProfile: '/api/v1/auth/me',
  },

  // Operating-mode reference: code -> {name, group, counts_hours, session_end},
  // both enum generations. The backend owns this mapping; fetch once per session.
  operatingModes: {
    getAll: '/api/v1/operating-modes',
  },

  // Analytics endpoints - NEW: Cross-customer/site analytics aggregation
  analytics: {
    getOperatingModesAggregate: '/api/v1/analytics/operating-modes/aggregate',
    getCycleTimesAggregate: '/api/v1/analytics/cycle-times/aggregate',
    getProductivityOverTime: '/api/v1/analytics/productivity/over-time',
    getHistoricalAverage: '/api/v1/analytics/historical-average',
    getTonnageAggregate: '/api/v1/analytics/tonnage/aggregate',
    getDistanceAggregate: '/api/v1/analytics/distance/aggregate',
  },
}
